<template>
  <div class="alarmDetail">
    <div>
      <div class="baseInfo">
        <p class="dom"></p>
        <p class="message">设备信息</p>
      </div>
      <div class="detail">
        <el-row :gutter="20">
          <el-col :span="7" :offset="3">
            <span>设备名称：</span><span>{{ deviceName }}</span>
          </el-col>
          <el-col :span="7">
            <span>设备编号：</span><span>{{ equipmentNo }}</span>
          </el-col>
          <el-col :span="7">
            <span>车牌号：</span><span>{{ plateNo }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 40px">
          <el-col :span="7" :offset="3">
            <span>设备吨位：</span><span>{{ equipmentTons }}</span>
          </el-col>
          <el-col :span="7">
            <span>设备类型：</span><span>{{ equipmentType }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="margin-top: 40px">
      <div class="baseInfo">
        <p class="dom"></p>
        <p class="message">风险信息</p>
      </div>
      <div class="detail">
        <el-row :gutter="20">
          <el-col :span="3" class="alarm"></el-col>
          <el-col :span="21" style="padding: 0">
            <el-row>
              <el-col
                :span="12"
                style="font-size: 19px; font-weight: bold; color: #2c2b30"
                >{{ alarmEventName }}</el-col
              >
              <el-col :span="12" style="font-size: 15px; color: #909399"
                ><span>风险类型：</span><span>{{ alarmType }}</span></el-col
              >
            </el-row>
            <el-row style="margin: 22px 0; color: #404040">
              <span>事件描述：</span>
              <span>{{ eventDesc }}</span>
            </el-row>
            <el-row style="margin: 22px 0; color: #404040">
              <span>事件后果：</span>
              <span>{{ eventEffect }}</span>
            </el-row>
            <el-row>
              <el-col :span="12">{{ address }}</el-col>
              <el-col :span="12" style="text-align: right">{{
                locationTime
              }}</el-col>
            </el-row>
            <el-row style="width: 100%; height: 350px; margin-top: 5px">
              <el-amap :center="[lng, lat]">
                <el-amap-marker
                  :position="[lng, lat]"
                  :content="iconContent"
                ></el-amap-marker>
              </el-amap>
            </el-row>
            <el-row style="margin: 30px 0">
              <el-col :span="22" >
                <span>处理状态：</span><span>{{dealStatus}}</span>
<!--                <el-input type="textarea" :rows="2" placeholder="请输入处理结果" v-model="textarea">-->
<!--                </el-input>-->
<!--                <el-button v-if="btnValue" type="success" icon="el-icon-check" circle title="点击处理" v-loading.fullscreen.lock="fullscreenLoading" style="margin-left: 10px;padding: 5px" @click="handleStatus"></el-button>-->

              </el-col>
              <el-col :span="14" style="margin-top: 10px"><el-input type="textarea" :rows="2" placeholder="请输入处理结果" v-model="textarea" v-bind:disabled="inputDis" maxlength="100" show-word-limit ref="input"></el-input></el-col>
              <el-col :span="6" style="margin-top: 25px"><el-button v-if="btnValue" type="success" icon="el-icon-check" circle title="点击处理" v-loading.fullscreen.lock="fullscreenLoading" style="margin-left: 10px;padding: 5px" @click="handleStatus"></el-button></el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import {handleWarningStatus} from '@/api/jyData';

export default {
  name: "AlarmDetail",
  props: {
    alarmDetailInfo: {
      type: Object,
      default: {},
      required: true,
    },
  },
  data() {
    let that = this;
    return {
      inputDis:true,
      textarea:"",
      btnValue:false,
      fullscreenLoading:false,
      id:"", //数据id
      deviceName: "", //设备名称
      equipmentNo: "", //设备编号
      plateNo: "", //车牌号
      equipmentTons: "", //设备吨位
      equipmentType: "", //设备类型
      alarmEventName: "", //风险事件名称
      alarmType: "", //风险类型
      eventDesc: "", //事件描述
      eventEffect: "", //事件后果
      address: "", //地址
      locationTime: "", //时间
      lat: "", //纬度
      lng: "", //经度
      dealStatus: "", //处理状态
      // 图标样式
      iconContent: `<div data-id="123" style="color: #fff;
								font-size: 12px;
								border: none;
								min-width: 20px;
								text-align: center;
								padding: 3px 4px;
								background: #FF4620;
								border-radius: 8px;">${this.alarmDetailInfo.baseInfo.name}</div>
								<img src="http://cp.juyiaqyy.com/images/juyiScreen/screen/device.png" style="width:25px;margin-left:3px;margin-top:5px;border-radius:50%;border:2px solid #FF4620;">
								`,
    };
  },
  created() {
    this.deviceName = this.alarmDetailInfo.baseInfo.name;
    this.equipmentNo = this.alarmDetailInfo.baseInfo.equipmentNo;
    this.plateNo = this.alarmDetailInfo.baseInfo.plateNo;
    this.equipmentTons = this.alarmDetailInfo.baseInfo.modelLabel;
    this.equipmentType = this.alarmDetailInfo.baseInfo.typeLabel;
    this.alarmEventName = this.alarmDetailInfo.alarmName;
    this.alarmType = this.alarmDetailInfo.alarmFromLabel;
    this.eventDesc = this.alarmDetailInfo.alarmDesc;
    this.eventEffect = this.alarmDetailInfo.alarmDanger;
    this.address = this.alarmDetailInfo.baseInfo.address;
    this.locationTime = this.alarmDetailInfo.baseInfo.locationTime;
    this.lat = this.alarmDetailInfo.lat;
    this.lng = this.alarmDetailInfo.lng;
    let status = this.alarmDetailInfo.dealStatus;
    if (status === 0) {
      this.dealStatus = "未处理";
      this.btnValue=true;
      this.inputDis=false;
    } else if (status === 1) {
      this.dealStatus = "已解决";
    } else {
      this.dealStatus = "已知晓";
    }
    this.id = this.alarmDetailInfo.id;
    this.textarea=this.alarmDetailInfo.warnDealRemarks;
  },
  methods: {
    handleStatus(){
      if (this.textarea){
        this.fullscreenLoading=true;
        let params = {
          id: this.id,
          dealStatus: 1,
          textarea:this.textarea
        };
        handleWarningStatus(params).then((res) => {
          if (res.code === 200||res.code === 0) {
            this.dealStatus = "已解决";
            this.fullscreenLoading=false;
            this.$emit("close-dialog",this.id,this.textarea);
          } else {
            this.$message.error("接口出错，请联系维护人员");
          }
        });
      }else {
        this.$message({
          message: '请填写内容..',
          type: 'warning'
        });
        this.$refs.input.focus();
      }

    },
    open3() {
      this.$message({
        message: '请填写内容..',
        type: 'warning'
      });
    },
  },
};
</script>

<style lang="less">
.alarmDetail {
  height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  .baseInfo {
    display: flex;
    .dom {
      border: 1px red solid;
      margin-right: 5px;
      width: 5px;
      height: 13px;
      background-color: red;
      margin-top: 2px;
    }
    .message {
      font-weight: bold;
      font-size: 17px;
    }
  }
  .detail {
    margin-top: 40px;
    font-size: 15px;
    color: #666666;
    .alarm {
      width: 40px;
      height: 100px;
      background: url("../../assets/images/kzuqi/alarm.png") no-repeat;
      background-size: 100%;
      margin: 0 15px 0 20px;
    }
  }
}
</style>
